import PropTypes from 'prop-types';
import { CatIconLock } from '@blocks-react/components/Icons/Lock';
import { CatIconPeople } from '@blocks-react/components/Icons/People';

const DealerListTypeCell = ({ isSharedWithUCID }) => {
  return (
    <div className="d-flex justify-content-center">
      {isSharedWithUCID ? <CatIconPeople /> : <CatIconLock />}
    </div>
  );
};

export default DealerListTypeCell;

DealerListTypeCell.propTypes = {
  isSharedWithUCID: PropTypes.bool
};
